import { scrollBy } from '../snippet/scroll';

const team = () => {
  const classes = {
    container: '.js--team-member-list',
    content: '.team-member-content-text',
    member: '.team-member',
    active: 'is-active',
  };
  const $teamContainer = $(classes.container);
  const $teamMemberContents = $(classes.content);
  const $body = $(document.body);

  $teamMemberContents.hide();

  const teamMemberToggler = (e) => {
    const $item = $(e.target);

    if (!$item.hasClass('icon')) {
      return;
    }

    const $teamMember = $item.closest(classes.member);
    const $content = $teamMember.find(classes.content);

    if ($content && !$teamMember.hasClass(classes.active)) {
      $teamMember.addClass(classes.active);
      $content.slideDown();
    } else {
      $teamMember.removeClass(classes.active);
      $content.slideUp();
    }

    scrollBy($body, $teamMember.offset().top);
  };

  $teamContainer.click(teamMemberToggler);
};

export default team;
